/* Montaje · arranca cuando se ve más de la mitad de la placa (y con las piezas ya cargadas, para que no aparezcan
   a medias), una sola vez; se queda en el último fotograma. «Ver de nuevo» lo repite (data-estado espera → anima,
   el mismo mecanismo que puede usar un «Míralo armado» de la página).
   Sin JS, con ?quieto=1 o con «menos movimiento» no se toca nada: la escena ya está terminada en el HTML. */
(() => {
  const quieto = new URLSearchParams(location.search).has("quieto") || matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (quieto || !("IntersectionObserver" in window)) return;

  document.querySelectorAll("[data-montaje]").forEach((el) => {
    const placa = el.querySelector(".montaje__placa") || el;
    el.dataset.estado = "espera";
    const reproducir = () => { el.dataset.estado = "espera"; void el.offsetWidth; el.dataset.estado = "anima"; };
    const otra = el.querySelector("[data-montaje-otra]");
    if (otra) otra.addEventListener("click", reproducir);

    // Las piezas se piden al acercarse la escena (no compiten con la foto del primer pantallazo)
    let cargadas;
    const cargar = () => cargadas || (cargadas = Promise.all([...new Set([...el.querySelectorAll("image")].map((i) => i.getAttribute("href")))]
      .map((src) => new Promise((ok) => { const im = new Image(); im.onload = im.onerror = ok; im.src = src; }))));
    const cerca = new IntersectionObserver(([e]) => { if (e.isIntersecting) { cargar(); cerca.disconnect(); } }, { rootMargin: "600px 0px" });
    cerca.observe(placa);

    const io = new IntersectionObserver((entradas) => entradas.forEach((e) => {
      const mitad = e.intersectionRatio >= 0.5 || e.intersectionRect.height >= innerHeight * 0.5;
      if (!e.isIntersecting || !mitad) return;
      io.disconnect();
      cargar().then(reproducir);
    }), { threshold: [0, 0.25, 0.5, 0.75, 1] });
    io.observe(placa);
  });
})();
